import React from "react";
import { inject, observer } from "mobx-react";
import { IAppStore } from "../../stores/Interfaces";
import { PermissionType, RoleType } from "../../constants/authorize";

interface Props {
  store?: IAppStore;
  permission?: PermissionType;
  role?: RoleType;
  children: React.ReactElement;
  deniedComponent?: React.ReactElement;
}

const Authorize: React.FC<Props> = ({
  store,
  permission,
  role,
  children,
  deniedComponent = null,
}) => {
  return store?.userStore.authorize(permission, role)
    ? children
    : deniedComponent;
};

export default inject("store")(observer(Authorize));
